// ip.service.ts
import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IpService {
  private ipAddress: string | null = null;

  constructor(private http: HttpClient,private httpBackend: HttpBackend) {
    this.http = new HttpClient(this.httpBackend);
  }


  async fetchPublicIp(): Promise<void> {
    try {
      const res: any = await firstValueFrom(
        this.http.get('https://api.ipify.org?format=json')
      );
      this.ipAddress = res.ip;
    } catch (error) {
      this.ipAddress = '0.0.0.0';
    }
  }


  getIp(): string {
    return this.ipAddress ?? '0.0.0.0';
  }
}
